import { useSelector } from 'react-redux';
import { teamsByIdSelector } from '../teams';

const useTeamById = teamId => {
  const teamsById = useSelector(teamsByIdSelector);
  const team = teamsById[teamId];

  return team;
};

export default useTeamById;
